import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const AnimatedSection = ({ 
  children, 
  className = '', 
  delay = 0,
  animationType = 'fadeUp'
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  const animationClasses = {
    fadeUp: isVisible 
      ? 'opacity-100 translate-y-0' 
      : 'opacity-0 translate-y-10',
    fadeIn: isVisible 
      ? 'opacity-100' 
      : 'opacity-0',
    slideLeft: isVisible 
      ? 'opacity-100 translate-x-0' 
      : 'opacity-0 -translate-x-10',
    slideRight: isVisible 
      ? 'opacity-100 translate-x-0' 
      : 'opacity-0 translate-x-10',
    scale: isVisible 
      ? 'opacity-100 scale-100' 
      : 'opacity-0 scale-95',
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${animationClasses[animationType]} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection;

